import { render, staticRenderFns } from "./ModalFairSeed.vue?vue&type=template&id=2a3a69f4&scoped=true"
import script from "./ModalFairSeed.vue?vue&type=script&lang=js"
export * from "./ModalFairSeed.vue?vue&type=script&lang=js"
import style0 from "./ModalFairSeed.vue?vue&type=style&index=0&id=2a3a69f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a69f4",
  null
  
)

export default component.exports